const UploadFileSkeleton = () => {
  return (
    <div className="flex justify-between animate-pulse">
      <section className="shadow-xl container w-fit items-start border border-dashed rounded-lg bg-gray-200">
        <div className="p-2 w-44 h-40 bg-gray-300 rounded-md"></div>
      </section>
      <div className="flex absolute">
        <div className="flex bg-gray-300 w-6 h-6 rounded-lg justify-center items-center"></div>
      </div>
    </div>
  );
};

export default UploadFileSkeleton;
